module.exports = __webpack_public_path__ + "img/category_puutarhakalusteet.56a1b5fb.jpeg";